/* ============================================================================
   CLEAR MEGA MENU — touch-first engine (theme port of the approved mockup).
   · All open/close state = .cdm-open class + aria-expanded (works everywhere).
   · Hover-intent acts ONLY on true hover devices (checked live per event —
     hybrids adapt). On touch, first tap opens (triggers are <button>s, never
     navigate); tap-again / tap-outside (scrim) / Esc close.
   · Mobile (≤1000px): Ergo-style drill-down inside the theme's
     .mobile-toggle-wrapper <details>; stack resets on reopen.
   · ?forcetouch=1 simulates a no-hover device for QA.
   See CD VS/TOUCH_NAV_DECISION.md for the full rationale + test history.
   ============================================================================ */
(function () {
  var OPEN_DELAY = 120, CLOSE_DELAY = 200;
  var root = document.querySelector('.cdm-root');
  if (!root) return;
  var items = [].slice.call(root.querySelectorAll('.cdm-item[data-cdm]'));
  var scrim = document.getElementById('cdmScrim');
  var FORCE_TOUCH = /[?&]forcetouch/.test(location.search);
  function hoverFine () {
    return !FORCE_TOUCH && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function syncScrim () {
    if (scrim) scrim.classList.toggle('cdm-show', !!root.querySelector('.cdm-item.cdm-open'));
  }
  function setOpen (item, on) {
    item.classList.toggle('cdm-open', on);
    var trig = item.querySelector('.cdm-link');
    if (trig && trig.tagName === 'BUTTON') trig.setAttribute('aria-expanded', on ? 'true' : 'false');
    syncScrim();
  }
  function closeAll () { items.forEach(function (i) { setOpen(i, false); }); }

  items.forEach(function (item) {
    var mega = item.querySelector('.cdm-mega');
    if (!mega) return;
    var trig = item.querySelector('.cdm-link');
    var openT = null, closeT = null;
    var open = function () { clearTimeout(closeT); openT = setTimeout(function () { setOpen(item, true); }, OPEN_DELAY); };
    var close = function () { clearTimeout(openT); closeT = setTimeout(function () { setOpen(item, false); }, CLOSE_DELAY); };
    item.addEventListener('mouseenter', function () { if (hoverFine()) open(); });
    item.addEventListener('mouseleave', function () { if (hoverFine()) close(); });

    /* keyboard focus opens on hover devices only — on touch, focus fires
       before click and would make the click toggle flash-and-shut */
    trig.addEventListener('focus', function () {
      if (!hoverFine()) return;
      clearTimeout(closeT); clearTimeout(openT);
      items.forEach(function (i) { if (i !== item) setOpen(i, false); });
      setOpen(item, true);
    });
    item.addEventListener('focusout', function (e) {
      if (hoverFine() && !item.contains(e.relatedTarget)) setOpen(item, false);
    });

    /* single activation path: click (mouse) / tap / Enter+Space (native button).
       Hover devices: click pins open (close stays on mouseleave). Touch: toggle. */
    trig.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(openT); clearTimeout(closeT);
      var wasOpen = item.classList.contains('cdm-open');
      items.forEach(function (i) { if (i !== item) setOpen(i, false); });
      setOpen(item, hoverFine() ? true : !wasOpen);
    });
  });

  /* tap/click outside closes (scrim lands here too) */
  document.addEventListener('pointerdown', function (e) {
    if (!root.querySelector('.cdm-item.cdm-open')) return;
    if (e.target.closest && e.target.closest('.cdm-item')) return;
    closeAll();
  }, { passive: true });

  /* Esc closes trays (refocusing the trigger) and the mobile drawer */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openItem = root.querySelector('.cdm-item.cdm-open');
    closeAll();
    if (openItem) { var t = openItem.querySelector('.cdm-link'); if (t) t.focus(); }
    var openDrawer = document.querySelector('.cdm-drawer.cdm-open');
    if (openDrawer) { openDrawer.classList.remove('cdm-open'); document.body.classList.remove('overflow-hidden'); }
    var wrap = document.querySelector('.mobile-toggle-wrapper[open]');
    if (wrap) wrap.removeAttribute('open');
  });

  /* ---------------- Software chip → caption swap: REMOVED 8/17 ----------------
     The Software tray's chip rail and fake-dashboard stage were retired in favour
     of four plain Sho Suite product cards, so there is no caption left to swap.
     The handler that drove it (data-cdm-cap parsing + [data-cdm-cap-*] targets)
     is gone with them. */

  /* ---------------- mobile drill-down ---------------- */
  var drawer = document.querySelector('.cdm-drawer');
  if (drawer) {
    var wrapEl = drawer.closest('.mobile-toggle-wrapper');
    var panels = {};
    [].slice.call(drawer.querySelectorAll('.cdm-panel')).forEach(function (p) { panels[p.getAttribute('data-cdm-panel')] = p; });
    var stack = ['root'];

    function show (focusTarget) {
      var cur = stack[stack.length - 1];
      Object.keys(panels).forEach(function (k) { panels[k].classList.remove('cdm-active', 'cdm-left'); });
      stack.slice(0, -1).forEach(function (id) { if (panels[id]) panels[id].classList.add('cdm-left'); });
      var panel = panels[cur];
      if (panel) {
        panel.classList.add('cdm-active');
        panel.scrollTop = 0;
        if (focusTarget !== false) {
          var f = panel.querySelector('.cdm-mback') || panel.querySelector('.cdm-mrow');
          if (f) f.focus({ preventScroll: true });
        }
      }
    }
    drawer.addEventListener('click', function (e) {
      var close = e.target.closest ? e.target.closest('.cdm-mclose') : null;
      if (close) {
        drawer.classList.remove('cdm-open');
        document.body.classList.remove('overflow-hidden');
        /* clear the theme's lingering open flags so the hamburger icon resets
           and header.js's state stays in sync (it doesn't see our Close) */
        if (wrapEl) { wrapEl.classList.remove('active'); wrapEl.removeAttribute('open'); }
        return;
      }
      var drill = e.target.closest ? e.target.closest('[data-cdm-drill]') : null;
      if (drill) { stack.push(drill.getAttribute('data-cdm-drill')); show(); return; }
      var back = e.target.closest ? e.target.closest('.cdm-mback') : null;
      if (back && stack.length > 1) { stack.pop(); show(); }
    });
    /* OWN the open/close ourselves so the drawer doesn't depend on the theme's
       header.js adding .active (which was unreliable on real devices/live —
       worked in isolation but not in the live environment). We toggle our own
       .cdm-open-m class on the wrapper on every hamburger tap; the reveal CSS
       keys on .cdm-open-m (with .active kept as a fallback). header.js's own
       handler still runs harmlessly alongside. */
    /* The header's .shopify-section wrapper has a CSS transform, which makes it
       the containing block for our position:fixed drawer and collapses it to 0
       height (invisible). Move the drawer to <body> so it sizes against the
       viewport. Then toggle .cdm-open ON THE DRAWER (no longer inside the
       wrapper) from our own hamburger handler — fully independent of the theme. */
    if (drawer.parentElement !== document.body) { document.body.appendChild(drawer); }
    if (wrapEl) {
      var summary = wrapEl.querySelector('.mobile-toggle, summary');
      if (summary) {
        summary.addEventListener('click', function () {
          var willOpen = !drawer.classList.contains('cdm-open');
          drawer.classList.toggle('cdm-open', willOpen);
          document.body.classList.toggle('overflow-hidden', willOpen);
          if (willOpen) { stack = ['root']; show(false); }
        });
      }
    }
    show(false);
  }
})();
